<template>
  <!-- Edit Appointment Button -->
  <q-btn color="amber" icon="edit" dense no-caps @click="prompt = true" />

  <!-- Edit Appointment Form -->
  <q-dialog v-model="prompt">
    <CustomerAppointmentForm :appointment-id="appointmentId" />
  </q-dialog>
</template>
<script>
import { ref } from 'vue'
import CustomerAppointmentForm from './AppointmentForm.vue'
export default {
  components: {
    CustomerAppointmentForm,
  },
  props: {
    appointmentId: String,
  },
  setup() {
    return {
      prompt: ref(false),
    }
  },
}
</script>
